import Vue from "vue";
import Vuex from "vuex";

export default class {
  constructor() {
    Vue.use(Vuex);
    const state = {
      isLoading: true,
      isIntialized: false,
      isError: true,
      currentPage: 1,
      totalPages: null,
      totalItems: null,
      filters: [],
      currentLocations: [],
      currentTypes: [],
      searchQuery: null,
      communities: [],
      api: null,
      indexName: null,
      filterImage: null,
      validQuery: null,
      headerText: '',
      searchFieldWatermark: '',
    };

    const mutations = {
      setApi(state, api) {
        state.api = api;
      },
      setValidQuery(state, validQuery) {
        state.validQuery = validQuery;
      },
      setError(state, error) {
        state.isError = error;
      },
      setLoading(state, loading) {
        state.isLoading = loading;
      },
      setIntialized(state, loading) {
        state.isIntialized = loading;
      },
      setCurrentPage(state, page) {
        state.currentPage = page;
      },
      setSearchQuery(state, query) {
        state.searchQuery = query;
      },
      setIndexName(state, indexName) {
        state.indexName = indexName;
      },
      setFilterImage(state, filterImage) {
        state.filterImage = filterImage;
      },
      setHeaderText(state, headerText) {
        state.headerText = headerText;
      },
      setSearchFieldWatermark(state, searchFieldWatermark) {
        state.searchFieldWatermark = searchFieldWatermark;
      },
      clearCurrentFilters(state){
        state.currentTypes = [];
        state.currentLocations = [];

      },

      setCurrentFilters(state, currentFilters) {
        if (currentFilters.length == 2) {
          if (currentFilters[0].length > 0 && currentFilters[1].length > 0) {
            var filterId = currentFilters[0].toLowerCase();
            var filterValueId = currentFilters[1].toLowerCase();
            switch (filterId) {
              case "location":
                state.currentLocations.indexOf(filterValueId) === -1
                  ? state.currentLocations.push(filterValueId)
                  : state.currentLocations.pop(filterValueId);
                break;
              case "type":
                state.currentTypes.indexOf(filterValueId) === -1
                  ? state.currentTypes.push(filterValueId)
                  : state.currentTypes.pop(filterValueId);
                break;
            }
          }
        }
      },
      setData(
        state,
        { totalPages, totalItems, filters, communities, page, query, filterImage, headerText, searchFieldWatermark }
      ) {
        if (totalPages != undefined) {
          state.totalPages = totalPages;
        }
        if (totalItems != undefined) {
          state.totalItems = totalItems;
        }
        if (filters != undefined) {
          state.filters = filters;
        }
        if (communities != undefined) {
          state.communities = communities;
        }
        if (page != undefined) {
          state.currentPage = page;
        }
        if (query != undefined) {
          state.searchQuery = query;
        }
        if (filterImage != undefined) {
          state.filterImage = filterImage;
        }
        if (headerText != undefined) {
          state.headerText = headerText;
        }
        if (searchFieldWatermark != undefined) {
          state.searchFieldWatermark = searchFieldWatermark;
        }
      },
    };
    const actions = {
      setFilters({ dispatch, commit }, p) {
        commit("setCurrentFilters", p);
        setTimeout(() => dispatch("getData"), 100);
      },
      setQuery({ dispatch, commit }, p) {
        if (p.length > 1) {
          commit("setSearchQuery", p);
          commit("setValidQuery", true);

          dispatch("getData");
        } else {
          commit("setValidQuery", false);
        }
      },
      getData({ commit, state }, p) {
        commit("setLoading", true);
        if (p != undefined) {
          commit("setData", p);
        }
        return new Promise(async (resolve) => {
          const request = await fetch(state.api, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              page: state.currentPage - 1,
              query: state.searchQuery,
              location: state.currentLocations,
              type: state.currentTypes,
              indexName: state.indexName,
             
            }), // read body data from store
          });

          if (request.ok) {
            const data = await request.json();
            commit("setData", data);
            commit("setLoading", false);
            commit("setIntialized", true);
            commit("setError", false);
            commit("setData", data);

          } else {
            commit("setError", true);
          }
          resolve();
        });
      },
    };

    this.store = new Vuex.Store({
      state,
      mutations,
      actions,
    });
  }
}
